import gql from "graphql-tag";

export const UPDATE_REPORTING_TEAMS_MApp_ANCHORS_FILTER = gql`
  mutation updateReportingTeamsMAppAnchorsFilter(
    $filter: ReportingTeamsMAppAnchorsFilterInput!
  ) {
    updateReportingTeamsMAppAnchorsFilter(filter: $filter) @client
  }
`;
